import baseRequest from './baseRequest';

export function getPrivacyPolicyTextScreenId() {
  return 'blend-privacy-policy-jan-2020';
}

export function getPrivacyPolicy() {
  const privacyPolicyId = getPrivacyPolicyTextScreenId();
  return baseRequest.get(`/api/text-screens/${privacyPolicyId}`);
}
